module.exports = __webpack_public_path__ + "static/media/ouro-preto-mg.20516dfb.jpg";